import { HStack, IconButton } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Icon } from '$/components/common/Icon';
import { ActionBarTooltip } from '$/components/core/Editor/ActionBar/components/ActionBarTooltip';
import { useCollectionViewOptions } from '$/hooks/useCollectionViewOptions';
import { useCollectionStore } from '$/stores/useCollectionStore';

export const CollectionViewOptionSelector = () => {
  const activeViewMode = useCollectionStore.useSelectedViewMode();
  const options = useCollectionViewOptions();
  const { t } = useTranslation();

  return (
    <HStack gap='3' display={{ base: 'none', mobile: 'flex' }}>
      {options.map((option) => {
        const tooltipLabel = t(`editor.${option.name}VisualizationDescription`);
        return (
          <ActionBarTooltip key={option.name} label={tooltipLabel}>
            <IconButton
              minW='0'
              minH='0'
              p='0'
              aria-label={option.name}
              icon={
                <Icon
                  icon={option.name}
                  height='24px'
                  fill={activeViewMode === option.name ? 'text' : 'lighterText'}
                  opacity={activeViewMode === option.name ? 1 : 0.3}
                />
              }
              onClick={() =>
                useCollectionStore.setState({ selectedViewMode: option.name })
              }
              variant='text'
            />
          </ActionBarTooltip>
        );
      })}
    </HStack>
  );
};
